import {Enum} from "./Utils/Unity/Enum";

export const GameScreen = Enum([
    "game",
    "monsters",
    "upgrades",
    "boosters",
    "collection",
    "map",
    "missions",
    "empty",
    "vip",
    "slots"
], "GameScreen");
export const GameCategory = Enum([
    "upgrade",
    "monster",
    "coins",
    "planet",
    "booster",
    "empty",
    "slots",
    "game_event"
    ], "GameCategory");
export const BoosterType = Enum([
    "Income",
    "CreaturesDiscount",
    "BubbleTime",
    "IncomeX4"
], "BoosterType");
export const UpgradeType = Enum([
    "BubbleTime",
    "MoneyBox",
    "Magnet",
    "MergeBonus",
    "BubbleCreature",
    "PlayerDamage",
    "EventBubbleTime",
    "EventBubbleMaxCharge",
    "EnemiesLevel",
    "TapChallengeMergeBonus",
], "UpgradeType");
export const MoneyType = Enum([
    "Soft",
    "Hard",
    "Spins",
], "MoneyType");
export const RewardType = Enum([
    "MoneySoft",
    "MoneyHard",
    "NoAds",
    "MoneySoftBySoftSpeed",
    "MaxCreature",
    "Vip",
    "RandomCreatureFromCurrentEpoch",
    "BoosterIncomeX4",
    "BoosterCreaturesDiscount",
    "Spins",
    "CreatureFromCollectionWithOffset",
    "LastShopCreature",
    "BoosterIncomeX2",
    "FirstCreatureOffer",
    "SkipEpochsOffer",
    "SpinsOffer1",
    "SpinsOffer2",
], "RewardType");
export const SlotItem = Enum([
    "MoneySoft1",
    "MoneySoft2",
    "Spin",
    "MoneyHard",
    "Creature1",
    "Creature2"
], "SlotItem");
export const UIState = Enum([
    "Loading",
    "Game",
    "BankSoft",
    "BankHard",
    "Boosters",
    "Map"
], "UIState");
export const SpinOfferType = Enum([
    "FirstLevel1",
    "FirstLevel2",
    "Second",
    "Complete"
], "SpinOfferType");
